<template>
  <div class="col-12 text-left">
    <div class="col-12 pa-0 pb-1" v-if="label">{{label}}</div>
    <ckeditor
      :id="id"
      :value="value"
      :config="editorConfig"
      :disabled="disabled"
      :read-only="readonly"
      tag-name="textarea"
      :editor-url="editorUrl"
      @input="$emit('input',$event)"
    />
  </div>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdInputEditor",
  mixins: [EdFormMixin],
  props: {
    type: {
      type: String,
      required: false,
      default: "text",
    },
  },
  data() {
    return {
      id: "ckeditor-" + this.$utilidade.randomString(),
      editorUrl: process.env.URL_API+"js/ckeditor447/ckeditor.js?v="+this.$root.$session.getClienteLogado.version,
      editorConfig: {
        language: "pt-br",
      },
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.inicialize();
  },
  computed: {},
  methods: {
    inicialize() {},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdInputEditor.vue